var _defs, _style, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82 92",
    width: 82,
    height: 92,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "delete") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 105,
    height: 103,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGkAAABnCAMAAAA0Vpx4AAAAAXNSR0IB2cksfwAAAGZQTFRF////////////////////////AAAACgoKCwsLICAgIyMjU1NTWVlZpqamrq6u/Pz8HR0dJycn/f39q6urt7e3f39/hISEi4uLAgICiYmJwMDAJCQkwcHBXV1dLi4uDg4OMDAwY2Njo/x/OAAAACJ0Uk5TBYj/SdcA////////////AP//AP/N//////+T/43//////8AT0TMAAADXSURBVHic7dpNC4JAEMbxHdtEFESEDn3/DxdRFBkU0et5q1lmU4Tk/xydh/150sOOOBE3SmQmj5Gk+TgOEhISUi8p/vV9Ik1VGvq3++0VkJCQ/ldyIXdLPtpHESQkpKlKPvkZEhISEhISEhISEhISEhISEhLSkJI1SEhI05eypGt0JdndIHm1lBB/NUi5WkpIfjFIhVpKSHE2SKWcekOVHA2Sq9WWOfVBHQU7H43es6XZ67Nwu6SVXQ+nlW1k+rbHspDNz1BVrWPjj42ZuhRZJStLka6LV16IVQN0QGb3PAAAAABJRU5ErkJggg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Background",
    href: "#img1",
    x: -4,
    y: -12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.5dff391b9d0044121a4127c6689e7404.svg";
export { ForwardRef as ReactComponent };